(function () {
  'use strict';

  if (window.__mkWishlistReady) return;
  window.__mkWishlistReady = true;

  var STORAGE_KEY = 'maison-ketenci-saved-products';
  var LEGACY_KEYS = ['maison-ketenci-wishlist', 'wishlist', 'wishlistItems', 'saved-products'];
  var saved = [];

  function unique(list) {
    var seen = Object.create(null);
    var result = [];

    if (!Array.isArray(list)) return result;

    list.forEach(function (item) {
      var handle = '';

      if (typeof item === 'string' || typeof item === 'number') {
        handle = String(item).trim();
      } else if (item && typeof item === 'object') {
        handle = String(item.handle || item.productHandle || item.product_handle || item.slug || '').trim();
      }

      if (!handle || seen[handle]) return;
      seen[handle] = true;
      result.push(handle);
    });

    return result;
  }

  function parseStored(value) {
    if (!value) return [];

    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return unique(parsed);
      if (parsed && Array.isArray(parsed.items)) return unique(parsed.items);
      if (parsed && Array.isArray(parsed.products)) return unique(parsed.products);
    } catch (error) {
      return unique(String(value).split(','));
    }

    return [];
  }

  function readStorage() {
    var list = [];

    try {
      list = parseStored(window.localStorage.getItem(STORAGE_KEY));

      if (!list.length) {
        for (var index = 0; index < LEGACY_KEYS.length; index += 1) {
          list = parseStored(window.localStorage.getItem(LEGACY_KEYS[index]));
          if (list.length) break;
        }
      }
    } catch (error) {
      // Keep the in-memory list when browser storage is unavailable.
    }

    return unique(list);
  }

  function writeStorage() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    } catch (error) {
      // The wishlist still works for the current page when storage is unavailable.
    }
  }

  function closestFavoriteButton(target) {
    if (!target) return null;
    if (target.nodeType === 3) target = target.parentElement;
    if (!target) return null;

    if (typeof target.closest === 'function') {
      return target.closest('[data-favorite-button]');
    }

    while (target && target !== document) {
      if (target.matches && target.matches('[data-favorite-button]')) return target;
      target = target.parentElement;
    }

    return null;
  }

  function savedLabel() {
    return window.maisonMarket && window.maisonMarket.savedLabel
      ? window.maisonMarket.savedLabel
      : 'Saved';
  }

  function saveLabel() {
    return window.maisonMarket && window.maisonMarket.saveLabel
      ? window.maisonMarket.saveLabel
      : 'Save item';
  }

  function updateButton(button) {
    if (!button) return;

    var handle = String(button.getAttribute('data-product-handle') || '').trim();
    if (!handle) return;

    var isSaved = saved.indexOf(handle) !== -1;
    button.classList.toggle('is-saved', isSaved);
    button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    button.setAttribute('aria-label', isSaved ? savedLabel() : saveLabel());

    var label = button.querySelector('[data-favorite-label]');
    if (label) label.textContent = isSaved ? savedLabel() : saveLabel();
  }

  function animateCounter(badge, link) {
    if (!badge || !link || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    badge.classList.remove('is-wishlist-updating');
    link.classList.remove('is-wishlist-updating');

    // Force a reflow so every new save restarts the animation.
    void badge.offsetWidth;

    badge.classList.add('is-wishlist-updating');
    link.classList.add('is-wishlist-updating');

    window.setTimeout(function () {
      badge.classList.remove('is-wishlist-updating');
      link.classList.remove('is-wishlist-updating');
    }, 560);
  }

  function render(options) {
    options = options || {};
    var count = saved.length;
    var visibleCount = count > 99 ? '99+' : String(count);

    document.querySelectorAll('[data-saved-count]').forEach(function (badge) {
      var link = badge.closest ? badge.closest('[data-saved-count-label]') : badge.parentElement;

      badge.textContent = visibleCount;
      badge.hidden = count === 0;
      badge.classList.toggle('is-hidden', count === 0);
      badge.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      badge.style.display = count === 0 ? 'none' : 'grid';

      if (options.animate && count > 0) animateCounter(badge, link);
    });

    document.querySelectorAll('[data-saved-count-label]').forEach(function (link) {
      var baseLabel = link.getAttribute('data-saved-count-label') || 'Saved items';
      link.setAttribute('aria-label', count ? baseLabel + ': ' + count : baseLabel);
      link.setAttribute('data-saved-count-value', String(count));
    });

    document.querySelectorAll('[data-favorite-button]').forEach(updateButton);
  }

  function dispatchChange(handle, isSaved) {
    var detail = { handle: handle, isSaved: isSaved, handles: saved.slice(), count: saved.length };

    try {
      document.dispatchEvent(new CustomEvent('maison:wishlist-change', { detail: detail }));
    } catch (error) {
      var legacyEvent = document.createEvent('CustomEvent');
      legacyEvent.initCustomEvent('maison:wishlist-change', true, true, detail);
      document.dispatchEvent(legacyEvent);
    }
  }

  function replace(nextList, options) {
    options = options || {};
    saved = unique(nextList);
    writeStorage();
    render({ animate: Boolean(options.animate) });
    dispatchChange(options.handle || '', Boolean(options.isSaved));
    return saved.slice();
  }

  function setSaved(handle, shouldSave) {
    handle = String(handle || '').trim();
    if (!handle) return saved.slice();

    var exists = saved.indexOf(handle) !== -1;
    if (exists === shouldSave) {
      render();
      return saved.slice();
    }

    if (shouldSave) {
      saved.push(handle);
    } else {
      saved = saved.filter(function (item) { return item !== handle; });
    }

    saved = unique(saved);
    writeStorage();
    render({ animate: shouldSave });
    dispatchChange(handle, shouldSave);
    return saved.slice();
  }

  function syncFromStorage() {
    saved = readStorage();
    render();
  }

  saved = readStorage();

  window.maisonSaved = {
    getHandles: function () { return saved.slice(); },
    getCount: function () { return saved.length; },
    has: function (handle) { return saved.indexOf(String(handle || '').trim()) !== -1; },
    add: function (handle) { return setSaved(handle, true); },
    remove: function (handle) { return setSaved(handle, false); },
    toggle: function (handle) {
      handle = String(handle || '').trim();
      return setSaved(handle, saved.indexOf(handle) === -1);
    },
    replace: replace,
    refresh: syncFromStorage
  };

  // Capture the click before card links or duplicate theme handlers can intercept it.
  document.addEventListener('click', function (event) {
    var button = closestFavoriteButton(event.target);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    window.maisonSaved.toggle(handle);
  }, true);

  window.addEventListener('storage', function (event) {
    if (event.key && event.key !== STORAGE_KEY && LEGACY_KEYS.indexOf(event.key) === -1) return;
    syncFromStorage();
  });

  window.addEventListener('pageshow', syncFromStorage);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) syncFromStorage();
  });

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(render, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { render(); }, { once: true });
  } else {
    render();
  }

  // Keep buttons and the header badge synchronized when Shopify or an app injects new markup.
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      var needsRender = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return false;
          if (node.matches && node.matches('[data-favorite-button], [data-saved-count], [data-saved-count-label]')) return true;
          return Boolean(node.querySelector && node.querySelector('[data-favorite-button], [data-saved-count], [data-saved-count-label]'));
        });
      });

      if (needsRender) window.requestAnimationFrame(function () { render(); });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
